<!-- 导出 -->
<template>
    <Layout>
        <div class="row">
            <div class="outBox">
                <div class="bs-top">
                    <img :src="imgOssSrc + 'bs-success.svg'">
                    <div class="cjcg">{{ appName }}导出成功</div>
                    <div class="u-tips-color" style="font-size: 14px">请复制下载链接到浏览器下载</div>
                </div>
                <div class="btn1" @click="copyLink">复制文件下载链接</div>
                <div class="btn2">
                    <a :href="downloadUrl" download=""></a>
                    下载文件
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
    var dayjs = require('dayjs')
    const d = new Date()
    const year = d.getFullYear()
    let month = d.getMonth() + 1
    month = month < 10 ? `0${month}` : month
    const date = d.getDate()

    import Layout from "../../layouts/main";
    import copyrightConfig from "@/utils/config/changeCopyright.js";
    import appConfig from "@/app.config";

    export default {
        page: {
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: { Layout },
        data(){
            return {
                imgOssSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/',
                downloadUrl: '',
                fileExtension: '', // 新增：存储文件后缀
                actName: '',
                routeParameter: {},
                appid: '', // 存储 appid
                appName: '接龙加加', // 默认应用名称
            }
        },
        mounted(){
            // 页面参数
            this.routeParameter = this.$route.query;
            if (this.routeParameter.actName){
                this.actName = this.routeParameter.actName;
            }
            if (this.routeParameter.appid) {
                this.appid = this.routeParameter.appid;
                // 根据 appid 设置不同的应用名称
                const appNames = {
                    'wx123456789': '接龙加加',
                    'wx987654321': '报名小程序',
                    'wx111111111': '活动报名'
                };
                this.appName = appNames[this.appid] || '接龙加加'; // 如果找不到对应的 appid，使用默认名称
            }
            if (this.routeParameter.downloadUrl){
                // 根据 appid 判断是否需要解码
                const needDecodeAppids = ['wx123456789', 'wx987654321']; // 需要解码的 appid 列表
                if (needDecodeAppids.includes(this.appid)) {
                    this.downloadUrl = decodeURIComponent(this.routeParameter.downloadUrl)
                } else {
                    this.downloadUrl = this.routeParameter.downloadUrl
                }
                console.log(this.downloadUrl ,'this.downloadUrl')
                // 获取文件后缀
                const fileName = this.downloadUrl.split('/').pop()
                const fileExt = fileName.split('.').pop()
                this.fileExtension = fileExt // 需要在data中定义fileExtension
                console.log(this.routeParameter.downloadUrl,'this.downloadUrl')
            }
            // 确保标题设置生效
            this.$nextTick(() => {
                this.setPageTitle();
            });
        },
        methods: {
            // 设置页面标题
            setPageTitle() {
                // 根据 AppID 确定后缀
                let suffix = '接龙加加';
                if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
                    suffix = '报名管家';
                }

                document.title = `导出成功 - ${suffix}`;
                console.log(document.title, "document.title");
            },
            copyLink(){
                this.copyTextToClipboard(this.downloadUrl)
                this.$message('复制成功');
            },
            async copyTextToClipboard(text) {
                try {
                    await navigator.clipboard.writeText(text);
                    console.log('Text copied to clipboard successfully!');
                } catch (err) {
                    console.error('Could not copy text: ', err);
                    // 如果Clipboard API不可用，则使用备用方案
                    this.fallbackCopyTextToClipboard(text);
                }
            },
            fallbackCopyTextToClipboard(text) {
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed'; // 避免在页面滚动时出现问题
                textarea.style.top = '-9999px';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                try {
                    const successful = document.execCommand('copy');
                    const msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Text copy was ' + msg);
                } catch (err) {
                    console.error('Could not copy text: ', err);
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .outBox{
        width: 1000px;
        margin: 0 auto;
        background-color: #fff;
        padding-bottom: 100px;
    }

    .bs-top{
        padding-top: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 25px;
        img{
            width: 70px;
            height: 70px;
            margin-bottom: 15px;
        }
        .cjcg{
            font-size: 16px;
            font-weight: bold;
            color: #656374;
            margin-bottom: 15px;
        }
        .fhjlxq{
            width: 190px;
            height: 45px;
            background: #ffffff;
            border: 1px solid #1877ff;
            border-radius: 25px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            color: #1877ff;
        }
    }
    .btn1{
        width: 80%;
        height: 45px;
        background-color: #1877ff;
        color: white;
        border: 1px solid #1877ff;
        text-align: center;
        line-height: 45px;
        font-size: 16px;
        border-radius: 22.5px;
        margin-left: 10%;
        cursor: pointer;
    }
    .btn2{
        width: 80%;
        height: 45px;
        background-color: #fff;
        color: #1877ff;
        border: 1px solid #1877ff;
        text-align: center;
        line-height: 45px;
        font-size: 16px;
        border-radius: 22.5px;
        margin-left: 10%;
        margin-top: 15px;
        position: relative;
        cursor: pointer;
        a{
            height: 100%;
            width: 100%;
            display: inline-block;
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .shareBtn{
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }

</style>
